import React from 'react'
import {Button, Header, Input, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import { createUserLog } from '../../lib/api';
import {useSelector} from "react-redux";

const KWDispatchPSM3 =({ data, channel, tags }) => {

    const [pwdisp, setPwdisp]= React.useState('');
    const [pwfac, setPwfact]= React.useState('');
    const [pwfmsg, setPwfmsg]= React.useState('');
    const [firstOpen, setFirstOpen] = React.useState(false);
    const [secondOpen, setSecondOpen] = React.useState(false);
    const [pwdispflag, setpwdispflag] = React.useState(false);
    const [pwfacflag, setfacflag] = React.useState(false);
    const [pwerror, setpwerror] = React.useState(false);
    let powfactor, powdispatch;

    // const HPEn = data[6032];
    let powFactorLimit = 0.85;
    let powFactorneg = -0.85;
    // update SOFC, 240307
    // let powerRating = (HPEn === 1) ? 460 : 440;//werRating
    let powerRating = 60;
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleModal =() => {
        setSecondOpen(false);
        setpwdispflag(false);
        setFirstOpen(true);
    }

    const handleModalClose =() => {
        setSecondOpen(false);
        setFirstOpen(false);
    }

    const handleOK = () => {
        powfactor = (typeof pwfac === 'undefined' || pwfac === '') ? data[14598] : pwfac; // OPERIN_POWFACT
        powdispatch = (typeof pwdisp === 'undefined' || pwdisp === '') ? data[14599] : pwdisp; // OPERIN_SETPOWER
        let dispKWValRaw = powdispatch;
        if(powdispatch < 9.9999 || powdispatch > powerRating){
            setSecondOpen(true);
            setpwdispflag(true);
        }
        if (dispKWValRaw >= 10 && dispKWValRaw <= powerRating) {
            if (dispKWValRaw <= 452) {
                powFactorLimit = 0.85;
                powFactorneg = -0.85;
            } else if (dispKWValRaw <= 453) {
                powFactorLimit = 0.852;
                powFactorneg = -0.852;
            } else if (dispKWValRaw <= 455) {
                powFactorLimit = 0.855;
                powFactorneg = -0.855;
            } else if (dispKWValRaw <= 456) {
                powFactorLimit = 0.857;
                powFactorneg = -0.857;
            } else if (dispKWValRaw <= 457) {
                powFactorLimit = 0.859;
                powFactorneg = -0.859;
            } else if (dispKWValRaw <= 458) {
                powFactorLimit = 0.861;
                powFactorneg = -0.861;
            } else if (dispKWValRaw <= 459) {
                powFactorLimit = 0.863;
                powFactorneg = -0.863;
            } else {
                powFactorLimit = 0.865;
                powFactorneg = -0.865;
            }

           if (pwerror || (powfactor < powFactorLimit && (Math.sign(powfactor) === 1)) ||
               (powfactor > powFactorneg && (Math.sign(powfactor) === -1)) ) {
                setSecondOpen(true);
                setPwfmsg(powFactorLimit);
                setfacflag(true);
            }
            else {
                var kwdata = {
                    'buttonClickType': channel,
                    'tags': [{'tag_id': 14598, 'tag_value': powfactor}, {'tag_id': 14599, 'tag_value': powdispatch}]
                };
                socket.emit('button click', kwdata);
                setSecondOpen(false);
                setFirstOpen(false);
                if (!electronApp) {
                   let log = {
                       user_id: user.id,
                       powerplant_id: ppid,
                       display_id: null,
                       datetime: new Date().toISOString(),
                       data: JSON.stringify({ tag_id: [14598, 14599] }),
                   };
                   createUserLog({ log }).catch(console.error);
                }
                setPwdisp('');
                setPwfact('');
            }
        }
        else {
            setSecondOpen(true);
        }
    }

    const handlePFactChange = (event, value) => {
        event.preventDefault();
        if(event.target.value < 0.85 && (Math.sign(event.target.value) === 1)){
            setPwfact(0.85);
            setpwerror(true);
        }
        else if(event.target.value >1.001 && (Math.sign(event.target.value) === 1)){
            setPwfact(Number(1.0).toFixed(1));
            setpwerror(true);
        }
        else if(event.target.value > -0.85 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.85);
            setpwerror(true);
        }
        else if(event.target.value <= -0.99999 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.99999);
            setpwerror(true);
        }
        else {
            setPwfact(event.target.value);
            setpwerror(false);
        }
    }

    const handlePwChange = (event, value) => {
        event.preventDefault();
        setPwdisp(event.target.value);
    }

    return (
        <div>
            <Button onClick={() => setFirstOpen(true)} color ='blue'>KW DISPATCH PSM3</Button>
                <Modal
                    onClose={() => setFirstOpen(false)}
                    onOpen={() => setFirstOpen(true)}
                    open={firstOpen}
                >
                    <Modal.Header>DISPATCHED POWER SETUP</Modal.Header>
                    <Modal.Description>
                        <Header style={styles.header}> POWER DISPATCH</Header>
                    </Modal.Description>
                    <Modal.Content>
                        <Modal.Description>
                            <Header style={styles.header}> SET POWER</Header>
                        <form autoComplete='off' style={styles.input} onSubmit={e => e.preventDefault()}>
                        <Input focus placeholder='Value'
                               name='Input change'
                               type='number'
                               step ='0.0001'
                               size='small'
                               min ='1'
                               max ='60'
                               onChange={(event, value) => handlePwChange(event, value)}
                               defaultValue={data[14599]}
                        />
                        </form>
                        </Modal.Description>
                        <Modal.Description>
                            <Header style={styles.header}> SET POWER FACTOR</Header>
                            <form autoComplete='off' style={styles.input} onSubmit={e => e.preventDefault()}>
                                <Input focus placeholder='Value'
                                       name='Input change'
                                       type='number'
                                       step ='0.0001'
                                       max = '1.0'
                                       size='small'
                                       onChange={(event, value) => handlePFactChange(event, value)}
                                       defaultValue={data[14598] === 1 ? Number(1.0).toFixed(1) : data[14598]}
                                />
                            </form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id='1'
                                content='OK'
                                onClick={handleOK}
                        />
                        <Button color={'red'}
                                size='small'
                                id='2'
                                content='Cancel'
                                onClick={() => setFirstOpen(false)}
                        />
                    </Modal.Actions>
                    { pwdispflag ?
                        <Modal
                            onClose={() => setSecondOpen(false)}
                            open={secondOpen}
                            size='small'
                        >
                            <Modal.Header>OUT OF RANGE</Modal.Header>
                            <Modal.Description>
                                <Header style={styles.header}> The Acceptable Range for Power Dispatch is
                                    1 to {powerRating}</Header>
                            </Modal.Description>
                            <Modal.Actions>
                                <Button color={'green'}
                                        size='small'
                                        id='1'
                                        content='OK'
                                        onClick={handleModal}
                                />
                                <Button color={'red'}
                                        size='small'
                                        id='2'
                                        content='Cancel'
                                        onClick={handleModalClose}
                                />
                            </Modal.Actions>
                        </Modal>
                        :
                        <Modal
                            onClose={() => setSecondOpen(false)}
                            open={secondOpen}
                            size='small'
                        >
                            <Modal.Header>OUT OF RANGE</Modal.Header>
                            <Modal.Description>
                                <Header style={styles.header}> The Acceptable Range for Power Factor Dispatch is
                                    {'+/-' + pwfmsg} to 1.0</Header>
                            </Modal.Description>
                            <Modal.Actions>
                                <Button color={'green'}
                                        size='small'
                                        id='1'
                                        content='OK'
                                        onClick={handleModal}
                                />
                                <Button color={'red'}
                                        size='small'
                                        id='2'
                                        content='Cancel'
                                        onClick={handleModalClose}
                                />
                            </Modal.Actions>
                        </Modal>
                    }
                </Modal>
       </div>
    );
}

const styles = {
    input: {
        padding: '5px',
        marginLeft: '5px'
    },
    toggle: {
        maxWidth: '300px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '10px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginRight: '40px',
        marginBottom: '5px'


    }
}

export default KWDispatchPSM3;

//{'+/-' + pwfmsg}